import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {FormPage} from '../../../shared/models/form-schema.model';
import {BlockRendererComponent} from '../block-renderer/block-renderer.component';

@Component({
  selector: 'forms-form-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, BlockRendererComponent],
  template: `
    <div class="form-page">
      <h2 *ngIf="page.title" class="text-xl font-bold text-gray-900 mb-4 tracking-tight">{{ page.title }}</h2>
      <div class="space-y-4">
        @for (block of page.blocks; track block.id) {
          <forms-block-renderer [block]="block" [parentForm]="formGroup"></forms-block-renderer>
        }
      </div>
    </div>
  `
})
export class FormPageComponent {
  @Input() page!: FormPage;
  @Input() formGroup!: FormGroup;
}
